import React from "react";
import UserLayout from "../layout/UserLayout";
import ContactFormRight from "../components/ContactFormRight";
import ContactSection from "../components/ContactSection";
import SocialMedia from "../components/SocialMedia";

const Contact = () => {
  return (
    <UserLayout>
      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-emerald-950 via-teal-950 to-stone-900 text-white pt-32 pb-20 px-6 sm:px-12 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="text-amber-400 font-semibold tracking-widest text-sm uppercase">
            Let's Talk Exports
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-3 mb-4 tracking-tight">
            Contact Ceymos Lanka
          </h1>
          <p className="text-lg text-emerald-100 max-w-2xl mx-auto leading-relaxed">
            Whether you are looking for bulk wholesale export, private labeling, or distributor partnerships, our export team is here to assist.
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <ContactFormRight />

      {/* Physical Info & Map Details */}
      <ContactSection />

      {/* Social Media Links */}
      <SocialMedia />
    </UserLayout>
  );
};

export default Contact;
